module.exports = __webpack_public_path__ + "assets/input.fd627960.svg";